export const defaultState = {
  certId: null,
  deltaClass: null,
  status: '',
  organization: null,
  validTill: null,
  dateDeltaCertificate: null,
};

const UPDATE_FIELD = 'UPDATE_FIELD';

export const updateFieldCreator = (payload) => ({ type: UPDATE_FIELD, payload });

export default function (state = defaultState, action) {
  if (action.type === UPDATE_FIELD) {
    if (action.payload.name === 'dateDeltaCertificate') {
      const newValidTil = new Date(action.payload.value);
      newValidTil.setFullYear(newValidTil.getFullYear() + 5);
      newValidTil.setDate(newValidTil.getDate() + 1);
      return { ...state, [action.payload.name]: action.payload.value, validTill: newValidTil };
    }
    return { ...state, [action.payload.name]: action.payload.value };
  }

  return state;
}
